export class Species{
  id:number;
  codigo:string;

  constructor(id,codigo){
    this.id = id;
    this.codigo = codigo;
  }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson(){
    return `{
      "data":{
        "type": "specie",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          "number":"${this.codigo}"
        }
      }
    }`;

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Species.ts